import { SoilThresholds } from "./SoilThresholds";

export default function Legend({
  chartProperty,
  isContinuous,
  minVal,
  maxVal,
  colorMap,
  gradientColors,
}: {
  chartProperty: string;
  isContinuous: boolean;
  minVal: number;
  maxVal: number;
  colorMap: Record<string, string>;
  gradientColors?: string[];
}): JSX.Element | null {
  if (!chartProperty) return null;

  // ✅ check if this property has soil thresholds
  const thresholds = SoilThresholds[chartProperty];

  return (
    <div
      style={{
        position: "absolute",
        bottom: "10px",
        left: "10px",
        background: "white",
        padding: "8px",
        borderRadius: "4px",
        fontSize: "12px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
        zIndex: 1001,
      }}
    >
      <strong>{chartProperty}</strong>
      <div style={{ marginTop: "4px" }}>
        {thresholds ? (
          // ✅ SOIL: show thresholds
          thresholds.map((t, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "2px",
              }}
            >
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: t.color,
                  marginRight: "6px",
                }}
              />
              {t.label}
            </div>
          ))
        ) : isContinuous ? (
          // ✅ NON-SOIL continuous (NDVI, DEM, etc.)
          <>
            <div
              style={{
                width: "120px",
                height: "12px",
                background: `linear-gradient(to right, ${
                  gradientColors?.join(",") || "#f7fbff,#08306b"
                })`,
                marginBottom: "4px",
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{minVal.toFixed(1)}</span>
              <span>{maxVal.toFixed(1)}</span>
            </div>
          </>
        ) : (
          // ✅ NON-SOIL categorical (land cover)
          Object.entries(colorMap).map(([cat, color]) => (
            <div
              key={cat}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "2px",
              }}
            >
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: color,
                  marginRight: "6px",
                }}
              />
              {cat}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
